export const attributeUUID = {
    addressInfo: "5687476396657640534",
    allergyInfo: "3487166764299587766",
    allergyContains: "5427524529574631114",
    allergyMayContain: "5758706855115796068",
    allergyDoesNotContain: "1713158213204877779",
    brand: "1880918225320644",
    certificationCodes: "9115096156523786015",
    correlationId: "5917934549819240072",
    createdOn: "1880918225330824",
    cvid: "1612687305328548785",
    cxHTaxonomy: "1418589967597792208",
    declaredBrand: "4363777319583581415",
    declaredManufacturer: "4507456670944212358",
    description: "1880918225320853",
    depth: "1880918225320651",
    drugPanel: "1880918225330765",
    energyPanel: "1880918225320763",
    gs1Segment: "1880918225320835",
    gs1Family: "1880918225320720",
    gs1Class: "1880918225320718",
    gs1Brick: "1880918225320719",
    gs1BarcodeType: "3034849527438661413",
    gs1PackageType: "8450610623358994700",
    guaranteedAnalysis: "1880918225320715",
    healthBeautyClaims: "1073279104625342461",
    healthIngredientClaims: "6610181004282960286",
    height: "1880918225320664",
    inhouseCategories: "1880918225320645",
    kosherCodes: "1932864567666522648",
    lightingPanel: "1880918225320764",
    manufacturer: "1880918225320833",
    metricHeight: "8296359384248898227",
    metricWidth: "4281680249936432188",
    metricDepth: "2540978288626893280",
    metricWeight: "7076108733582926691",
    metricHeightUOM: "3507142172395422614",
    metricWidthUOM: "7783295636981914900",
    metricDepthUOM: "4143760252411892993",
    metricWeightUOM: "5088560941221629506",
    modifier: "1880918225320709",
    netWeight: "6219959714124870377",
    nutritionPanel: "1880918225320762",
    packageDepthUOM: "5730993383079810864",
    packageHeightUOM: "6563456574939115286",
    packageWeightUOM: "6579477390734151335",
    packageWidthUOM: "6050011397755309199",
    packageMarketingCopy: "2098991593890630223",
    pdfFiles: "6543569295683429330",
    prepInstructions: "5761066931759447496",
    productMatch: "4848411431897431371",
    recycleCodes: "5261677646496855340",
    smDescription: "1880918225320728",
    supplementPanel: "1880918225320766",
    supplierProductName: "1062821264565135574",
    syndigoCustomProductName: "375403917348085921",
    upc: "1880918225320734",
    updatedBy: "1880918225330825",
    updatedOn: "1880918225330826",
    weight: "6219959714124870377",
    width: "1880918225320739",
    imageApprovedAttr: "5916381868279382308",
    deprecatedCountry: "6891092253500346048",
    country: "4088651474286157630",
};

export const uuidName = Object.keys(attributeUUID).reduce(function (obj, key) {
    obj[attributeUUID[key]] = key;

    return obj;
}, {});

export const lookupUUID = (attr) => {
    return attr in attributeUUID ? attributeUUID[attr] : "";
};

// TODO: Remove after GS1 gets component
export const convertToUUID = (payload) => {
    const uuidPayload = {};
    Object.keys(payload).forEach((key) => {
        if (key in attributeUUID) {
            uuidPayload[attributeUUID[key]] = payload[key];
        } else {
            uuidPayload[key] = payload[key];
        }
    });

    return uuidPayload;
};

export const convertToName = (payload) => {
    const namePayload = {};
    Object.keys(payload).forEach((key) => {
        if (key in uuidName) {
            namePayload[uuidName[key]] = payload[key];
        } else {
            namePayload[key] = payload[key];
        }
    });

    return namePayload;
};
